import React from "react";
import cn from "classnames";
import { Checkbox, CheckboxProps, Form } from "rsuite";
import {
    ITenantFeatureSettingWorkFlow,
    TenantFeatureSettingWorkFlowType,
    WorkflowModalType,
    WorkflowStatus,
} from "utils/tenant-workflows/tenant-workflows-types";
import {
    getTenantFeatureSettingByType,
    isTenantFeatureSettingWithTypeEnabled,
} from "utils/tenant-workflows/tenant-workflows-helper";

import { Features } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

import ProcessModalButton from "components/WorkflowLog/ProcessModalButton/ProcessModalButton";

import css from "./TenantFeatureSettingsCheckbox.module.css";
import "../FeatureConfigurations.less";

interface IComponentProps extends CheckboxProps {
    tenantFeatureSettingWorkFlows: ITenantFeatureSettingWorkFlow[] | null;
    disabledSettingNames: string[];
    tenantFeatureSettingWorkFlowType: TenantFeatureSettingWorkFlowType;
    buttonText: string;
    helpText: string;
    onCheckboxChange: (name: keyof Features, value: boolean) => void;
    triggerRefresh?: () => void;
}

const TenantFeatureSettingsCheckbox: React.FC<IComponentProps> = ({
    tenantFeatureSettingWorkFlows,
    disabledSettingNames,
    tenantFeatureSettingWorkFlowType,
    buttonText,
    helpText,
    value,
    checked,
    disabled,
    onCheckboxChange,
    triggerRefresh,
}: IComponentProps) => {
    const tenantFeatureSettingWorkFlow = getTenantFeatureSettingByType(
        tenantFeatureSettingWorkFlows,
        tenantFeatureSettingWorkFlowType
    );
    const isEnabled =
        tenantFeatureSettingWorkFlow !== null &&
        tenantFeatureSettingWorkFlow.status !== WorkflowStatus.Terminated
            ? !disabledSettingNames.includes(
                  tenantFeatureSettingWorkFlow.featureName
              ) &&
              isTenantFeatureSettingWithTypeEnabled(
                  tenantFeatureSettingWorkFlows,
                  tenantFeatureSettingWorkFlowType
              )
            : true;

    return (
        <Form.Group
            className={cn("gridItem", "feature-configurations__less-height")}
        >
            <Checkbox
                className={"feature-configurations__checkbox"}
                value={value}
                checked={checked}
                disabled={!isEnabled || disabled}
                onChange={(_, checked) =>
                    onCheckboxChange(value as keyof Features, checked)
                }
            >
                <div>
                    {buttonText}
                    {tenantFeatureSettingWorkFlow !== null && (
                        <ProcessModalButton
                            workflow={tenantFeatureSettingWorkFlow}
                            className={css.processModalButton}
                            workflowType={WorkflowModalType.Feature}
                            triggerRefresh={triggerRefresh}
                        />
                    )}
                    <Form.HelpText
                        tooltip
                        className={"feature-configurations__help-block"}
                    >
                        {helpText}
                    </Form.HelpText>
                </div>
            </Checkbox>
        </Form.Group>
    );
};

export default TenantFeatureSettingsCheckbox;
